<div *transloco="let t; read: 'liatActivation.printContent'">
    <div class="print-header">
        <div class="header-title">
            <h1>
                {{ t('headerTitle') }}
            </h1>
            <p class="subtitle">
                {{ t('headerSubtitle') }}
            </p>
        </div>
        <div class="roche-logo">
            <img width="50" height="30" src="assets/logo_roche.svg" alt="Roche logo" />
        </div>
    </div>
    <br>
    <p>
        <span>{{ t('paragraph1Text1') }}</span><br>
        <span class="pt-2">{{ t('paragraph1Text2') }}</span>
    </p>
    <br>
    <table class="registration-keys-table" *ngIf="tableData && tableData.length > 0">
        <thead>
            <th>{{ t('tableHeader1') }}</th>
            <th>{{ t('tableHeader2') }}</th>
            <th>{{ t('tableHeader3') }}</th>
        </thead>
        <tbody>
            <tr *ngFor="let regData of tableData">
                <td>
                    {{regData.additionalInput}}
                </td>
                <td>
                    {{regData.token}}
                </td>
                <td>
                    <img *ngIf="regData?.tokenBarcode" width="auto" height="25px" src="data:image/gif;base64,{{regData.tokenBarcode}}" alt=""/>
                </td>
            </tr>    
        </tbody>
    </table>
    <br>
    <p class="pt-5">{{ t('paragraph2Text1') }}</p>
    <br>
    <p>
        <span>{{ t('paragraph2Text2') }}</span><br>
        <span class="pt-2">{{ t('paragraph2Text3') }}</span>
    </p>
</div>